import { loadLocale, inferContentLanguage, inferPrimaryIntlLocale } from 'app/infrastructure/platform';
import { globalVar } from 'app/infrastructure/universal';
import { parse } from 'query-string';
import { AppSetting } from 'dependencies/appsettings';

/**
 * Inject selected whitelisted flags from url
 * 
 * url has querystring containing `?debug` or `&debug`:
 *  - enables configuration info panels for components
 *  - enables debug logging
 */
function injectTransientSettings(){
  
  const location = globalVar('location');
  
  if (!location){
    return;
  }

  const query = location.search ? location.search.slice(1) : null;
  const params = parse(query);

  if (params.debug !== undefined) {
    AppSetting.ClientDebugLog = true;
    AppSetting.ComponentDebug = true;
  }
}

/**
 * AppShell is responsible for work to be performed before first render
 */
export class AppShell {

  /**
   * Two letter ISO 639 code. The first in the list of users current (UI) languages. 
   * Resolved from 
   * 
   *  - 1: language from the Accept-Language header
   *  - 2: language from the browser locale setting
   */
  public static language: string;
  /**
   * IETF language tag. 
   * Resolved from:
   * - 1: browser setting navigator.languages 
   * - 2: fallbacks resolving from accept-language HTTP header
   */
  public static locale: string;

  /**
   * Ensure browser compatibility and loading of Intl formats
   */
  public async initialize() {

    AppShell.language = inferContentLanguage();
        
    await loadLocale();
    
    AppShell.locale = inferPrimaryIntlLocale();

    injectTransientSettings();
  }
}
